import React, {useEffect} from 'react';
import {useIntl} from 'react-intl';
import {useDispatch} from 'react-redux';
import FilterTextField from '../../../_common/components/FilterTextField';
import FiltersLabel from '../../../_common/components/FiltersLabel';
import * as actions from '../../_redux/popupConfirmCustomerActions';
import {RequestCancellationManager} from '../../../_common/utils/RequestCancellationManager';
import styles from './styles.module.scss';

const CustomersFilters = ({
                            popupBasicData,
                            formikProps: {
                              values,
                              handleBlur,
                              setFieldValue,
                              handleSubmit
                            }
                          }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const searchByName = intl.formatMessage({
    id: 'invoice-orders-popup-create-customer-filter-name',
    defaultMessage: 'Name'
  });
  const searchByPhone = intl.formatMessage({
    id: 'invoice-orders-popup-create-customer-filter-phone',
    defaultMessage: 'Phone'
  });
  const searchByEmail = intl.formatMessage({
    id: 'invoice-orders-popup-create-customer-filter-email',
    defaultMessage: 'Email'
  });
  const searchByID = intl.formatMessage({
    id: 'invoice-orders-popup-create-customer-filter-id',
    defaultMessage: 'ID'
  });
  const searchByCustomerId = intl.formatMessage({
    id: 'invoice-orders-popup-create-customer-filter-customerID',
    defaultMessage: 'Customer ID'
  });

  const data = [
    {fieldName: 'filterByName', placeholder: searchByName},
    {fieldName: 'filterByIdNumber', placeholder: searchByID},
    {fieldName: 'filterByPhone', placeholder: searchByPhone},
    {fieldName: 'filterByEmail', placeholder: searchByEmail},
    {fieldName: 'filterByCustomerId', placeholder: searchByCustomerId},
  ];

  const getFilters = (data) => {
    return data && data.map((item, index) => {
      return (
        <div className={styles.filter} key={index}>
          <FilterTextField
            fieldName={item.fieldName}
            value={values[item.fieldName]}
            placeholder={item.placeholder}
            handleBlur={handleBlur}
            setFieldValue={setFieldValue}
            handleSubmit={handleSubmit}
          />
        </div>
      );
    });
  };

  useEffect(() => {
    RequestCancellationManager.stopRequests(actions.getPossibleCustomersListIDPrefix);

    dispatch(actions.getPossibleCustomersList(
      popupBasicData.idNumber,
      popupBasicData.phone,
      popupBasicData.emailRecipients,
      values.filterByName,
      values.filterByPhone,
      values.filterByEmail,
      values.filterByIdNumber,
      values.filterByCustomerId,
    ));
  }, [
    values.filterByName,
    values.filterByPhone,
    values.filterByEmail,
    values.filterByIdNumber,
    values.filterByCustomerId,
  ]);

  return (
    <div className={styles.customersFiltersContainer}>
      <FiltersLabel/>
      {getFilters(data)}
    </div>
  );
};

export default CustomersFilters;
